/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".frame[_ngcontent-%COMP%]{width:100%;height:450px;border:none}.box-content[_ngcontent-%COMP%]{box-sizing:border-box;display:block;height:100%;width:100%;padding:1rem}.footer[_ngcontent-%COMP%]{border-top:1px solid rgba(120,130,140,.13);padding:1rem}.link[_ngcontent-%COMP%]{display:inline-block;cursor:pointer;padding:1rem}.link.active[_ngcontent-%COMP%]{border-bottom:2px solid #21d196}.iframe-wrapper[_ngcontent-%COMP%]{margin:auto;width:350px}@media screen and (max-width:600px){.iframe-wrapper[_ngcontent-%COMP%]{width:100%}}"];
export { styles as styles };
